import React, { useEffect, useState } from "react";
import { DashboardLayout, FormParser,PopupModal } from "../Components";
import { NavLink,useParams } from "react-router-dom";
import Masters from "../Components/masters.json"
import "./Pages.css"
import axiosConfig from "../Service/axiosConfig"
const PriorityEdit = () => {
    const[popupType,setpopupType]=useState("")
    const[Error,SetError]=useState("")
    const MastersModal=Masters.Priority
    const formSubmit=(Data)=>{
        axiosConfig.put(`/masters/priority/${id}/`,Data).then(res=>{
                   console.log(res)
                   setpopupType("success")
        }).catch(error=>{
            console.log(error)
            const ErrorData=[]
            ErrorData.push({
                code:error.response.data.code||["null"],
                name:error.response.data.name||["null"],
                    })
                    console.log(ErrorData[0])
            if(ErrorData[0].code[0]==="priority with this code already exists."){
                SetError(" code already exists.")
            }
            if(ErrorData[0].name[0]==="priority with this name already exists."){
                SetError("Tittle already Exists")
            }
            setpopupType("error")
        })
      }
    let { id } = useParams();
    const [Data, SetData] = useState([])
    const GetData = async () => {
        try {
            const responce = await axiosConfig.get(`/masters/priority/${id}/`)
            console.log(responce)
            SetData(responce.data)
        }
        catch (error) {
            console.log(error)
        }

    }
    useEffect(() => {
        GetData();
    }, [])
    return (
        <>
            <DashboardLayout>
                <div className="dashboard-header">
                    <h5 className="dashboard-subtitle">Edit Priority {id}</h5>
                    <NavLink to="/dashboard/masters/priority" ><button className="btn btn-white">Manage</button></NavLink>
                </div>
                <FormParser modelObject={MastersModal} formData={Data} formSubmit={formSubmit} error={Error}/>
                {popupType != "" &&
                    <PopupModal popupType={popupType} Navigation="/dashboard/masters/priority" />
                }
            </DashboardLayout>
        </>
    )

}
export {PriorityEdit}